import store from '@/store'

export default {
	uimaker:{
		'ui-select':{
			stringValue:true,
			pageFields(){
				return {page:'page',rows:'limit'};
			}
		},
		'ui-attachment':{
			responseError(response){
				return response.code!=0;
			}
		},
		'ui-image':{
			responseError(response){
				console.log(response)
				return response.code!=0;
			}
		}
	},
	commonui:{
		'com-search':{
			pageFields(){
				return {page:'page',rows:'limit'};
			}
		},
		'com-table':{
			pageFields(){
				return {page:'page',rows:'limit'};
			}
		},
	}
}
